import { START_LOCATION } from 'vue-router'
import type { RouterConfig } from '@nuxt/schema'

export default <RouterConfig>{
  scrollBehavior(to, from, savedPosition) {
    // On initial hydration after a full page load/reload, let the browser handle scroll restoration.
    if (from === START_LOCATION) {
      return false
    }

    // Back/forward navigation.
    if (savedPosition) {
      return savedPosition
    }

    // Same path (query-only updates, e.g. wizard state) — keep current scroll.
    // Still honor a newly set hash on the same path.
    if (to.path === from.path) {
      if (to.hash && to.hash !== from.hash) {
        return { el: to.hash }
      }
      return false
    }

    // Hash navigation (anchor). Our global smooth-anchors plugin handles click scrolling,
    // but this keeps behavior correct for direct URL hash navigations and programmatic router pushes.
    if (to.hash) {
      return { el: to.hash }
    }

    // Default for route navigations.
    return { top: 0 }
  }
}

